/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { compose, withReducer, withHandlers, mapProps } from '../../../../utils/hoc';

const LOAD = '@@list/LOAD';
const TOGGLE_ALL = '@@list/TOGGLE_ALL';
const TOGGLE_SEVERITY = '@@list/TOGGLE_SEVERITY';


/**
 * Example State
 * [{
 *   serviceKey: 'coreService', major: true, minor: true, maintenance: true
 * }, {
 *   serviceKey: 'api', major: true, minor: true, maintenance: false
 * }, {
 *   serviceKey: 'web', major: false, minor: false, maintenance: false
 * }]
 */

export const initialState = { major: false, minor: false, maintenance: false };

const reducer = (state=[], action) => {
  switch (action.type) {
    case LOAD: {
      return action.value;
    }
    case TOGGLE_ALL: {
      const { value } = action;
      return { major: value, minor: value, maintenance: value };
    }
    case TOGGLE_SEVERITY: {
      const { severity, value } = action;
      return { ...state, [severity]: value };
    }
    default: {
      return state;
    }
  }
};

const connect = () => compose(
  withReducer('severityGrid', 'dispatch',
    reducer,

  ),
  withHandlers({
    load: ({ dispatch }) => (value) => dispatch({
      type: LOAD,
      value,
    }),
    toggleAll: ({ dispatch }) => (value) => dispatch({
      type: TOGGLE_ALL,
      value,
    }),
    toggleSeverity: ({ dispatch }) => (severity, value) => dispatch({
      type: TOGGLE_SEVERITY,
      severity,
      value
    }),
  }),
  mapProps(({ severityGrid, load, toggleAll, toggleSeverity, dispatch, ...rest }) => {
    const _severityGrid = { state: severityGrid, actions: { load, toggleAll, toggleSeverity } };
    return { severityGrid: _severityGrid, ...rest };
  })
);


export default connect;
